import LayoutContainer from 'components/Common/LayoutContainer'
import Pane from 'components/Common/Pane'
import PaneBody from 'components/Common/Pane/PaneBody'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import Heading from 'components/Luxkit/Typography/Heading'
import Image from 'components/Common/Image'
import React, { useEffect } from 'react'
import fetchMerchandiseAdverts from 'actions/merchandise/fetchMerchandiseAdverts'
import { useAppDispatch } from 'hooks/reduxHooks'
import { connect } from 'react-redux'
import Group from 'components/utils/Group'

interface Props {
  advertCatalogue: App.StatefulData<App.AdvertCatalogue>;
}

function MarketplacePage(props: Props) {
  const {
    advertCatalogue,
  } = props
  const dispatch = useAppDispatch()
  useEffect(() => dispatch(fetchMerchandiseAdverts()), [dispatch])

  return <Pane
    // @ts-ignore
    axis="vertical"
    id="main-content"
  >
    <PaneBody size="xl-y">
      <VerticalSpacer gap={40} >
        <Heading align="center" variant="heading2">Browse our merchandise offerings</Heading>
        <LayoutContainer>
          <Group
            as="label"
            verticalAlign="center"
            horizontalAlign="space-evenly"
            direction="horizontal"
          >
            {advertCatalogue?.data?.advertItems.map(product => (
              <Group key={product.id} gap={12} direction="vertical" verticalAlign="center">
                <Image
                  id={product.imageId}
                  width="250"
                  fit="center"
                />
                <h2>{product.name}</h2>
                <h2>{product.category}</h2>
                <h2>${product.price.toFixed(2)}</h2>
              </Group>
            ))}
          </Group>
        </LayoutContainer>
      </VerticalSpacer>
    </PaneBody>
  </Pane>
}

const mapStateToProps = (state: App.State) => ({
  advertCatalogue: state.merchandise.advertCatalogue,
})

export default connect(mapStateToProps)(MarketplacePage)
